// @flow
import { Record } from 'immutable';

type CatalogRecordShape = {
  id: ?string,
  name: ?string,
  logo_url: ?string,
  group_id: ?string,
  group_name: ?string,
};

const defaultCatalogRecord: CatalogRecordShape = {
  id: null,
  name: '',
  logo_url: '',
  group_id: null,
  group_name: null,
};

export default class Catalog extends Record(defaultCatalogRecord) {
  static Empty = new Catalog();
}



// WEBPACK FOOTER //
// ./src/models/Catalog.js